import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { softControlMotion } from '@/theme/interactions';

export const ShortcutGroup = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-width: 0;
`;

export const ShortcutLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  max-width: 100%;
  box-sizing: border-box;
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.color.hairSoft};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.color.surface};
  font-family: ${({ theme }) => theme.font.body};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: 600;
  overflow-wrap: anywhere;
  && {
    color: ${({ theme }) => theme.color.textPrimary};
    text-decoration: none;
  }
  svg {
    flex-shrink: 0;
    color: ${({ theme }) => theme.color.textMuted};
  }
  ${softControlMotion}
  &:hover {
    background-color: ${({ theme }) =>
      `color-mix(in srgb, ${theme.color.surface} 94%, ${theme.color.textPrimary})`};
  }
  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.color.focusRing};
    outline-offset: 3px;
  }
`;
